import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Question from '../Question/Question';

const QuizTopic = () => {

    const quizItems = useLoaderData();
    const { id, name, logo, questions, total } = quizItems.data;

    return (
        <div className='mt-5'>
            <h1 className='text-2xl font-bold'>Quiz Topic: {name}</h1>
            <h1>Total Question: {total}</h1>
            <p>Correct Ans: {total}</p>
            {
                questions.map(question => <Question key={question.id} question={question}></Question>)
            }
        </div>
    );
};

export default QuizTopic;